export const DELAY_FOLLOW_UP_RECORD = 'DELAY_FOLLOW_UP_RECORD';


// WEBPACK FOOTER //
// ./src/store/types.js